<template>
  <div class="operation-wrapper">
    <div class="operation-container">
      <div v-for="item in operationInfo" :key="item.id" class="operation-item flex-start" @click.stop="toPath(item)">
        <img :src="item.icon" alt="" :class="item.className">
        <span>{{ item.label }}</span>
      </div>
    </div>
    <div class="mask" @click="handleClose"></div>
  </div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		name: 'job-more-info',
		data () {
			return {
				operationInfo: [
					{
						id: 1,
						label: '求职意向',
						icon: 'https://files.wondercv.com/jobs/iconshoutixiang.png',
						router: true,
						path: '/job/intentions',
						className: 'icon-1'
					},
					{
						id: 2,
						label: '收藏职位',
						icon: 'https://files.wondercv.com/jobs/iconxingxing.png',
						path: '/job/intentions/my_favorite_job',
						className: 'icon-2'
					},
					{
						id: 3,
						label: '已投职位',
						icon: 'https://files.wondercv.com/jobs/iconduigou.png',
						path: '/job/recommands',
						className: 'icon-3'
					},
					{
						id: 4,
						label: '网申提醒',
						icon: 'https://files.wondercv.com/jobs/iconlingdang.png',
						path: '/user_settings/net_application',
						className: 'icon-4'
					}
				]
			}
		},
		mounted () {
			this.initOperation()
		},
		computed: {
		},
		watch: {},
		components: {},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			toPath (item) {
				if (item.router) {
					this.$router.push({ path: item.path, query: { jobs: 1 } })
				} else {
					window.location.href = process.env.VUE_APP_LINK + item.path
				}
				this.handleClose()
			},
			initOperation () {
				if (!this.userData.is_student) this.operationInfo.splice(3, 1)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .operation-container {
    position: absolute;
    top: 43px;
    right: 24px;
    z-index: 11;
    padding: 0 24px;
    box-shadow: 0 4px 10px 0 rgba($color: #D7D7D7, $alpha: .5);
    background-color: $color-light;
    border-radius: 4px;
    .operation-item {
      padding: 16px 0;
      border-bottom: 1px solid #ECECEC;
      color: $color-title;
      line-height: 20px;
      img {
        width: 18px;
        margin-right: 18px;
      }
      .icon-3, .icon-1 {
        width: 16px;
      }
      &:last-child {
        border: none;
      }
    }
  }
  .mask {
    position: fixed;
    top: 44px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
    z-index: 9;
  }
</style>
